<form [formGroup]="createMasterValueForm" class="create-master-wrapper">
  <!-- Header -->
  <div class="custom-modal-header">
    <h4 class="modal-title">{{dialogTitle}}</h4>
    <p class="modal-subtitle">{{dialogSubTitle}}</p>
  </div>

  <!-- Master Name -->
  <div class="custom-control input-wrapper">
    <app-gis-custom-input
      label="Master Value Name"
      formControlName="masterValueName"
      [maxLength]="64"
      [isDisabled]="isEdit">
    </app-gis-custom-input>
  <!-- Only show character count if no errors -->
  <mat-hint class="character-count" *ngIf="!hasError(createMasterValueForm.get('masterValueName'), 'required') && !hasError(createMasterValueForm.get('masterValueName'), 'maxlength')">
    {{ createMasterValueForm.get('masterValueName')?.value?.length || 0 }}/64 characters
  </mat-hint>

    <div class="error-message" *ngIf="hasError(createMasterValueForm.get('masterValueName'), 'required')">
      Master Value Name is required.
    </div>
    <div class="error-message" *ngIf="hasError(createMasterValueForm.get('masterValueName'), 'maxlength')">
      Maximum 64 characters allowed.
    </div>
    <div class="error-message" *ngIf="hasError(createMasterValueForm.get('masterValueName'), 'pattern')">
  Only letters, numbers, and underscore (_) are allowed.
</div>
  </div>

  <!-- Dynamic Rows for Language + Label -->
  <div formArrayName="masterValueLabels">
    <div
      class="master-label-wrapper"
      *ngFor="let group of masterValueLabels.controls; let i = index"
      [formGroupName]="i"
    >
      <!-- Language -->
      <div class="custom-control">
        <app-gis-select label="Select Language" formControlName="language" [options]="language_list"></app-gis-select>
        <div class="error-message" *ngIf="hasError(group.get('language'), 'required')">
          Language is required.
        </div>
      </div>

      <!-- Label -->
      <div class="custom-control">
        <app-gis-custom-input
          label="Master Value Label"
          formControlName="label"
          [maxLength]="64">
        </app-gis-custom-input>
          <!-- Only show character count if no errors -->
  <mat-hint class="character-count character-count-label" *ngIf="!hasError(group.get('label'), 'required') && !hasError(group.get('label'), 'maxlength')">
    {{ group.get('label')?.value?.length || 0 }}/64 characters
  </mat-hint>
        <div class="error-message" *ngIf="hasError(group.get('label'), 'required')">
          Label is required.
        </div>
        <div class="error-message" *ngIf="hasError(group.get('label'), 'maxlength')">
          Maximum 64 characters allowed.
        </div>
      </div>

      <!-- Remove Button -->
      <app-gis-primary-button
        *ngIf="masterValueLabels.length > 1"
        button_label="&times;"
        [class]="'remove-btn'"
        (click)="removeLabelRow(i)">
      </app-gis-primary-button>
<!-- -->
      <!-- Add Button (only last row) -->
      <app-gis-primary-button
        button_label="+"
        [class]="'add-btn'"
        (click)="addLabelRow()"
        *ngIf="i === masterValueLabels.length - 1 && masterValueLabels.length + 1 <=  language_list.length " >
      </app-gis-primary-button>
    </div>
  </div>

  <!-- Parent Master -->
  <div class="custom-control">
    <app-gis-select label="Select Master" [options]="optionMasterData" formControlName="parentMaster"></app-gis-select>
    <div class="error-message" *ngIf="hasError(createMasterValueForm.get('parentMaster'), 'required')">
      Master  Name is required.
    </div>
  </div>
<!-- Active Status Toggle -->
  <div class="custom-control status-toggle-wrapper">
    <label class="status-label">Status</label>
    <mat-slide-toggle
      class="status"
      [checked]="isStatusActive"
      (change)="onStatusChange($event.checked)">
    </mat-slide-toggle>
  </div>
  <!-- Footer -->
  <div class="panel-footer">
    <app-gis-primary-button
      button_label="Cancel"
      class="reset-btn"
      (click)="onCancel()">
    </app-gis-primary-button>

    <app-gis-primary-button
      button_label="Submit"
      [class]="'gis-primary-button'"
      (click)="onSubmit()">
    </app-gis-primary-button>
  </div>
</form>
<!-- Loading indicator -->
  <ngx-loading
    [show]="isLoading"
    [config]="{ backdropBackgroundColour: 'rgba(255,255,255,0.3)' }"
  ></ngx-loading>
